import { FormHelperText, TextField } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'
import { useField } from 'formik'
import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { materialDatePickerTheme } from '../OverrideStyles'
import './style.css'

type DatepickerProps = {
  dirtyValue?: boolean
  disabled?: boolean
  disableFuture?: boolean
  label: string
  name: string
  setFieldValue: any
  style?: object
  value?: any
}

const ValidatedDatePicker = ({
  dirtyValue,
  disabled,
  disableFuture,
  label,
  name,
  setFieldValue,
  value,
}: DatepickerProps) => {
  const [field, meta] = useField(name)

  const error = !!(meta.error && meta.value && field.onBlur)

  const helperText = error ? meta.error : null
  const maxDate = !disableFuture ? undefined : new Date()

  const [date, setDate] = React.useState(value ? new Date(value) : new Date())
  const handleCalendarClose = () => setFieldValue(name, date)

  return (
    <ThemeProvider theme={materialDatePickerTheme}>
      <DatePicker
        customInput={
          <TextField
            disabled={disabled}
            InputLabelProps={{ shrink: true }}
            label={label}
            name={name}
            variant="outlined"
          />
        }
        disabled={disabled}
        maxDate={maxDate}
        name={name}
        onCalendarClose={handleCalendarClose}
        onChange={(selectedDate: Date) => setDate(selectedDate)}
        selected={date}
      />
      <FormHelperText>{dirtyValue && value != null ? meta.error : helperText}</FormHelperText>
    </ThemeProvider>
  )
}

export default ValidatedDatePicker
